module.exports = __webpack_public_path__ + "static/media/4. Florecer, Mixta, óleo, esmalte, acrílico y papel s_madera, 160 x 80cm.2018 copy.37cf6502.png";